import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getAuditLogs = createAsyncThunk(
  "auditLogs/getAuditLogs",
  async ({ currentPage, itemsPerPage, userTypes, actionType, fromDate, toDate, search }, { rejectWithValue }) => {
    try {
      // Build query parameters
      let queryParams = `page=${currentPage}&limit=${itemsPerPage}`;

      // Add filter parameters only if they exist and have values
      if (userTypes && userTypes.length > 0) {
        queryParams += `&user_type=${userTypes.join(',')}`;
      }
      if (actionType && actionType.trim() !== "") {
        queryParams += `&action_type=${actionType}`;
      }
      if (fromDate && fromDate.trim() !== "") {
        queryParams += `&from_date=${fromDate}`;
      }
      if (toDate && toDate.trim() !== "") {
        queryParams += `&to_date=${toDate}`;
      }
      if (search && search.trim() !== "") {
        queryParams += `&search=${search}`;
      }

      const response = await getMethod(`/api/audit-logs?${queryParams}`);
      const json = await response.json();
      return json;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch logs");
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
  pagination: {},
};

const auditLogsSlice = createSlice({
  name: "auditLogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getAuditLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.pagination = action.payload.pagination;
        state.success = true;
        state.error = null;
      })
      .addCase(getAuditLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch audit logs";
        state.success = false;
      });
  },
});
export default auditLogsSlice.reducer;
